import React, { useEffect, useState } from "react";

import { Modal } from "antd";
import dayjs from "dayjs";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useDispatch } from "react-redux";
import Layout from "../../Layout";
import moment from "moment";
import NotificationService from "../../Services/NotificationService";
import { getNotificationCount } from "../../Redux/actions/NotificationActions";

function Notification() {
  const [notifications, setNotifications] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [message, setMessage] = useState({});
  const [hasMore, setHasMore] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const dispatch = useDispatch();

  const patJson = localStorage.getItem("patientData");
  const patObj = patJson ? JSON.parse(patJson) : null;

  const getNotificationList = async (pageNo = 1, pageSize = 9) => {
    if (!patObj) return;

    const payload = {
      account_Id: patObj?.account_Id,
      clinic_id: patObj?.clinic_Id,
      patientId: patObj?.patientId,
      status: 1,
      pageNo,
      pageSize,
    };

    const result = await NotificationService.NotificationList(payload);
    const allData = result.data || [];
    setNotifications(allData);
    if (result.data.length === payload.pageSize) {
      setHasMore(true);
    }

    if (result.data.length === pageSize) {
      setTotalPages(pageNo + 1);
    } else {
      setTotalPages(pageNo);
    }

    setCurrentPage(pageNo);
  };

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      getNotificationList(page);
    }
  };

  useEffect(() => {
    getNotificationList();
  }, []);

  const handleOk = () => setIsModalOpen(false);
  const handleCancel = () => setIsModalOpen(false);

  const truncateContent = (content) => {
    const words = content.split(" ");
    return words.length > 10 ? `${words.slice(0, 10).join(" ")} ...` : content;
  };

  const convertUTCDate = (date, format) => {
    if (!format) {
      const d = new Date();
      date = new Date(
        moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
          " " +
          d.getHours() +
          ":" +
          d.getMinutes()
      );
    }
    format = format || "MM/DD/YYYY"; // YYYY-MM-DD hh:mm:ss
    return moment(new Date(date)).utc().format(format);
    // return moment(new Date(date)).add(moment(date).utcOffset(), 'm').utc().seconds(30).format(format);
  };

  const markAsRead = async (record) => {
    let payload = {
      id: record.id,
      countStatus: "Y",
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
    };
    try {
      let result = await NotificationService.NotificationUpdate(payload);
      setNotifications((prevNotifications) =>
        prevNotifications.map((notif) =>
          notif.id === record.id ? { ...notif, countStatus: "Y" } : notif
        )
      );
      let countStatus = await dispatch(getNotificationCount());
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Layout>
      <div className=" mt-4">
        {/* Notification Cards */}
        <div className="grid grid-cols-3 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {notifications.map((record, index) => (
            <div
              key={index}
              onClick={(e) => {
                setIsModalOpen(true);
                setMessage(record);
                markAsRead(record);
              }}
              className={`rounded-lg shadow p-4 cursor-pointer hover:shadow-md transition-all ${
                record.countStatus === "N" ? "bg-blue-50" : "bg-white"
              }`}
            >
              <div className="text-sm text-gray-500 mb-2">
                {dayjs(record.date).format("DD/MM/YYYY")}
              </div>

              <div className="flex items-center justify-between mb-1">
                <div className="font-semibold text-lg">{record.subject}</div>
                {record.countStatus === "N" && (
                  <span className="text-xs bg-blue-500 text-white rounded-full px-2 py-0.5">
                    New
                  </span>
                )}
              </div>

              <div className="text-gray-700 text-sm mb-2">
                {truncateContent(record.content)}
              </div>
            </div>
          ))}
        </div>
        <div className="h-[49px] w-full border rounded-md flex justify-end items-center p-5">
          <div className="flex items-center justify-center space-x-2">
            <button
              className={`p-2 rounded-md ${
                currentPage === 1
                  ? "text-gray-400 cursor-not-allowed bg-white"
                  : "text-gray-700 bg-white"
              }`}
              onClick={() => goToPage(currentPage - 1)}
              disabled={currentPage === 1}
            >
              <FaChevronLeft className="text-[#189FAA]" />
            </button>

            {[...Array(totalPages)].map((_, index) => {
              const page = index + 1;
              return (
                <button
                  key={page}
                  className={`px-3 py-1 rounded-md ${
                    currentPage === page
                      ? "bg-teal-500 text-white text-sm"
                      : "text-gray-700 text-sm hover:bg-gray-200 bg-white border rounded-md"
                  }`}
                  onClick={() => goToPage(page)}
                >
                  {page}
                </button>
              );
            })}

            <button
              className={`p-2 rounded-md ${
                currentPage === totalPages
                  ? "text-gray-400 cursor-not-allowed bg-white"
                  : "text-gray-700 bg-white"
              }`}
              onClick={() => goToPage(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              <FaChevronRight className="text-[#189FAA]" />
            </button>
          </div>
        </div>

        <Modal
          title={
            <div className="flex items-center border-b border-brand-colorBorder pb-4">
              <h3 className="mb-0 text-lg font-semibold tracking-wider ml-3">
                {dayjs(message.date).format("DD/MM/YYYY")}
              </h3>
            </div>
          }
          footer={[]}
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          width="45%"
        >
          <div className="flex flex-col gap-2 ">
            <div className="font-bold">{message.subject} :</div>
            <div>{message.content}</div>
          </div>
        </Modal>
      </div>
    </Layout>
  );
}

export default Notification;
